import React from 'react'
import { Ratings as StarRating } from '@sainsburys-tech/bolt'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { openAccordion } from '../../helpers/openAccordion'
import { runBVReviewsTrack } from '../../helpers/bazaarVoiceTracking'

import * as Styled from './ReviewsFlag.styles'
import Ratings from '@/components/Ratings/Ratings'
import { useFeatureFlagContext } from '../../providers/FeatureFlagContext/FeatureFlagContext'

const ReviewsLink = ({ reviewCount = 0, reviewMessage = 'Read reviews' }) => {
  const countSpan = <span itemProp='ratingCount'>{reviewCount}</span>
  const linkMessage = reviewCount > 0 ? reviewMessage : ''
  return (
    <Styled.Link data-test='reviews-flag-link'>
      {linkMessage} ({countSpan})
    </Styled.Link>
  )
}

const ReviewsFlag = ({ overallRating, reviewCount, breadcrumb, partNumber, attributes }) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  const trackReviewSummaryClick = () => {
    const element = '#reviews'
    openAccordion(element)
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_reviewStarRating',
        eventAction: 'Reviews Star Rating'
      }
    })
    // BazaarVoice Analytics Tracking
    runBVReviewsTrack(
      'FeaturedEvent',
      { breadcrumb, partNumber, attributes },
      'link',
      'pdp_reviewStarRating',
      'PrimaryRatingSummary'
    )
  }

  const hasReviews = reviewCount > 0

  if (!hasReviews) return null
  if (PDP_V2_FLAG)
    return <Ratings onClickHandler={trackReviewSummaryClick} overallRating={overallRating} reviewCount={reviewCount} />
  return (
    <Styled.Wrapper>
      <Styled.StarRatingWrapper
        data-test='reviews-flag'
        onClick={trackReviewSummaryClick}
        onKeyPress={trackReviewSummaryClick}
        role='link'
        tabIndex='0'
        isLinkMessageShown={!!reviewCount}
        itemProp='aggregateRating'
        itemType='https://schema.org/AggregateRating'
        itemScope
      >
        <StarRating
          large
          rating={overallRating}
          position='left'
          message={<ReviewsLink reviewCount={reviewCount} overallRating={overallRating} />}
          style={{ marginBottom: '4px' }}
          data-test='heading-ratings'
        />
        <meta itemProp='ratingValue' content={overallRating} />
        <meta itemProp='worstRating' content='1' />
        <meta itemProp='bestRating' content='5' />
      </Styled.StarRatingWrapper>
    </Styled.Wrapper>
  )
}

export default ReviewsFlag
